import { render } from "./BuildingCategoriesTable.vue?vue&type=template&id=7540aae6"
import script from "./BuildingCategoriesTable.vue?vue&type=script&lang=js"
export * from "./BuildingCategoriesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__